import { Node } from 'tiptap'
import { Plugin } from 'prosemirror-state'

const alignLeft = 'respondeco-editor__figure--left'
const alignCenter = 'respondeco-editor__figure--center'
const alignRight = 'respondeco-editor__figure--right'

export class Figure extends Node {
  get name() {
    return 'figure'
  }

  get schema() {
    return {
      attrs: { align: { default: alignCenter } },
      content: 'image figcaption',
      group: 'block',
      parseDOM: [
        {
          tag: 'figure',
          getAttrs: (dom: HTMLElement) => {
            let align = alignCenter

            if (dom.classList.contains(alignLeft)) {
              align = alignLeft
            } else if (dom.classList.contains(alignRight)) {
              align = alignRight
            }

            return { align }
          },
        },
      ],
      toDOM: (node: Node) => [
        'figure',
        {
          class: node.attrs.align,
        },
        0,
      ],
    }
  }

  // Deletes the entire figure node if imageNode is empty.
  get plugins() {
    return [
      new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
          const tr = newState.tr
          let modified = false
          // TO-DO: Iterate through transactions instead of descendants.
          newState.doc.descendants((node, pos) => {
            if (node.type.name != 'figure') return
            const imageNode: any = node.firstChild

            if (
              imageNode.attrs.src == imageNode.type.defaultAttrs.src &&
              imageNode.attrs.alt == imageNode.type.defaultAttrs.alt
            ) {
              tr.deleteRange(pos, pos + node.nodeSize)
              modified = true
            }
          })
          if (modified) return tr
        },
      }),
    ]
  }

  commands({ type, schema }: any) {
    return (attrs: ImageCommand) => (state: any, dispatch: any) => {
      if (attrs.type === 'insert') {
        const { tr, selection } = state
        const pos = selection.$cursor ? selection.$cursor.pos : selection.$to.pos

        const node = type.create(null, [
          schema.nodes.image.create({
            alt: attrs.caption,
            src: attrs.src,
          }),
          schema.nodes.figcaption.create(null, schema.text(attrs.caption ?? 'Bildbeschreibung')),
        ])

        dispatch(tr.insert(pos - 1, node))
      } else {
        let align: string = alignCenter

        if (attrs.value === 'left') {
          if (state.selection.$from.parent.attrs.align === alignLeft) {
            align = alignCenter
          } else {
            align = alignLeft
          }
        } else if (attrs.value === 'right') {
          if (state.selection.$from.parent.attrs.align === alignRight) {
            align = alignCenter
          } else {
            align = alignRight
          }
        }

        dispatch(
          state.tr.setNodeMarkup(state.selection.$from.before(), undefined, {
            align,
          })
        )
      }
    }
  }
}

type ImageCommand = InsertImage | AlignImage

type InsertImage = {
  caption?: string
  src: string
  type: 'insert'
}

type AlignImage = {
  type: 'align'
  value: 'left' | 'center' | 'right'
}
